module.exports = __webpack_public_path__ + "img/alpine.e24541f2.jpg";